module.exports = __webpack_public_path__ + "img/Frame 1105one2.2146fe80.png";